import { useState, useEffect } from 'react';

const useCanPlayThrough = (videoRef) => {
  const [canPlayThrough, setCanPlayThrough] = useState(false);

  useEffect(() => {
    const handleCanPlayThrough = () => {
      setCanPlayThrough(true);
    };

    const video = videoRef.current;
    if (video) {
      video.addEventListener('canplaythrough', handleCanPlayThrough);

      // Cleanup listener on unmount
      return () => {
        video.removeEventListener('canplaythrough', handleCanPlayThrough);
      };
    }
  }, [videoRef]); // Re-run effect if videoRef changes

  return canPlayThrough;
};

export default useCanPlayThrough;
